import { RouteRecordRaw } from 'vue-router';

let routes: RouteRecordRaw[] = [
    {
        path: '/pushSentLog',
        name: 'pushSentLog',
        meta: { sideMenuLabel: "Log push" },
        component: () => import("./views/pushSentLog.vue")
    },
];

export default routes;